export enum WidgetId {
  LoyaltyStatus = 'f30e2cf0-de22-453e-ac3b-973c84cd4311',
}
